var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlightsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-ui-name": "Airplane",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    "data-name": "Airplane",
    "data-group": "m"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.38 4.85l2.692-2.69a.544.544 0 11.769.768L11.149 5.62l1.356 6.781a1.733 1.733 0 01-.474 1.565.115.115 0 01-.184-.03L8.841 7.927l-3.076 3.076v2.551a.218.218 0 01-.372.154l-3.102-3.102a.218.218 0 01.154-.372h2.55l3.077-3.076-6.01-3.004a.116.116 0 01-.03-.185A1.733 1.733 0 013.6 3.495l6.78 1.355zM1.17 5.943l3.527 1.764-.529.528H2.446C.47 8.234-.52 10.623.878 12.02l3.102 3.102c1.397 1.397 3.786.408 3.786-1.568v-1.722l.528-.529 1.764 3.528a2.116 2.116 0 003.388.55 3.733 3.733 0 001.02-3.372L13.32 6.277l1.935-1.934A2.544 2.544 0 0011.657.745L9.724 2.68 3.99 1.534a3.733 3.733 0 00-3.37 1.02 2.116 2.116 0 00.55 3.388z",
    shapeRendering: "geometricPrecision"
  })));
}
export default SvgFlightsIcon;